<template>
  <div>
    <Header></Header>
    <!-- <div class="homeCon" @mousewheel.prevent>
      <div class="mainPage">
        <img src="../../assets/main.png" alt="" />
      </div>
      <div class="articlePage">
        <div class="box" @click="showModal(article[0].id)">
          <div class="boxCon boxCon1">
            <img :src="article[0].image" alt="">
            <div class="info">
              <div class="title">{{article[0].title}}</div>
              <div class="author">{{article[0].author}}</div>
            </div>
          </div>
        </div>
        <div class="box" @click="showModal(article[1].id)">
          <div class="boxCon boxCon2">
            <img :src="article[1].image" alt="">
            <div class="info">
              <div class="title">{{article[1].title}}</div>
              <div class="author">{{article[1].author}}</div>
            </div>
          </div>
        </div>
        <div class="box" @click="showModal(article[2].id)">
          <div class="boxCon boxCon3">
            <img :src="article[2].image" alt="">
            <div class="info">
              <div class="title">{{article[2].title}}</div>
              <div class="author">{{article[2].author}}</div>
            </div>
          </div>
        </div>
        <div class="box box4" @click="showModal(article[3].id)">
          <div class="boxCon boxCon4">
            <img :src="article[3].image" alt="">
            <div class="info">
              <div class="title">{{article[3].title}}</div>
              <div class="author">{{article[3].author}}</div>
            </div>
          </div>
        </div>
        <div class="listBox">
          <router-link to="/article">
            <div class="toArticle">ARTICLE</div>
          </router-link>
        </div>
      </div>
      <div class="modal" ref="modal" @scroll.stop.prevent>
        <a-modal
          v-model="visible"
          :getContainer="() => $refs.modal"
          width="40vh"
          :zIndex=3
          centered
          :footer="null"
          :closable="false"
          @ok="handleOk"
        >
          <p v-html="item"></p>
        </a-modal>
        <div class="return" v-if="visible" @click="closeModal"></div>
      </div>
      <div class="magezinePage">
        <div class="listBox">
          <div class="aged">AGED</div>
          <hr />
          <div class="beyound">BEYOUND</div>
          <hr />
          <div class="construct">CONSTRUCT</div>
          <hr />
          <div class="departure">DEPARTURE</div>
          <hr />
          <div class="o2">O2</div>
          <hr />
          <div class="hua">HUA</div>
          <hr />
        </div>
      </div>
      <div class="activityPage">
          <div class="listBox">
              <div class="toActivity">STEP INTO</div>
              <hr />
          </div>
      </div>
    </div> -->
    <full-page :options="options" ref="page">
      <div class="section">
        <div class="mainPage">
          <!-- <img :src="banner" alt=""/> -->
          <div id="particles-js"></div>
        </div>
      </div>
      <div class="section">
        <div class="articlePage">
          <div class="box" @click="showModal(article[0].id)">
            <div class="boxCon boxCon1">
              <img :src="article[0].image" alt="" />
              <div class="info">
                <div class="title">{{article[0].title}}</div>
                <div class="author">{{article[0].author}}</div>
              </div>
            </div>
          </div>
          <div class="box" @click="showModal(article[1].id)">
            <div class="boxCon boxCon2">
              <img :src="article[1].image" alt="" />
              <div class="info">
                <div class="title">{{article[1].title}}</div>
                <div class="author">{{article[1].author}}</div>
              </div>
            </div>
          </div>
          <div class="box" @click="showModal(article[2].id)">
            <div class="boxCon boxCon3">
              <img :src="article[2].image" alt="" />
              <div class="info">
                <div class="title">{{article[2].title}}</div>
                <div class="author">{{article[2].author}}</div>
              </div>
            </div>
          </div>
          <div class="box box4" @click="showModal(article[3].id)">
            <div class="boxCon boxCon4">
              <img :src="article[3].image" alt="" />
              <div class="info">
                <div class="title">{{article[3].title}}</div>
                <div class="author">{{article[3].author}}</div>
              </div>
            </div>
          </div>
          <div class="listBox">
            <router-link to="/article">
              <div class="toArticle">
                <div class="con">
                  ARTICLE
                </div>
                <div class="icon"></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="section">
        <div class="magezinePage">
          <div class="listBox">
            <div class="box" v-for="item,index in magazine" :key="index">
              <router-link :to="{name:'/magazine',params:{magazine:item.title}}">
                <div class="con">
                  {{item.title}}
                  <div class="icon"></div>
                </div>
                
              </router-link>
              <hr />
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="section">
        <div class="activityPage">
          <div class="listBox">
            <div class="toActivity">
              <div class="con">
                  STEP INTO
              </div>
              <div class="icon"></div>
            </div>
            <hr />
          </div>
        </div>
      </div> -->
      <div class="section footer">
        <Footer></Footer>
      </div>
    </full-page>
    <div class="modal" ref="modal">
      <a-modal
        v-model="visible"
        :getContainer="() => $refs.modal"
        width="40vh"
        :zIndex=3
        centered
        :footer="null"
        :closable="false"
        :destroyOnClose="true"
        @cancel="onCancel"
      >
        <p v-html="item"></p>
      </a-modal>
      <div class="return" v-if="visible" @click="closeModal"></div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import particlesConfig from '../../assets/particles.json'
export default{
  components:{
      Header,
      Footer
  },
  data() {
    return {
      visible: false,
      banner:'',
      article:[],
      item:{},
      magazine:[],
      options: {
        // key
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        navigation: false,
        autoScrolling: true
      }
    }
  },
  created() {
    this.getBanner()
    this.getData_article()
    this.getData_magazine()
  },
  updated() {
    particlesJS('particles-js',particlesConfig)
  },
  methods: {
    async getBanner(){
      const banner = await this.$axios.get("steppyplus", {});
      this.banner = banner.data.stepintobrands_banner
    },
    async getData_article() {
      const articleId = await this.$axios.get("steppyplus", {
      });
      for (let i = 0; i < articleId.data.pc_article.length; i++) {
        const article = await this.$axios.get("article/"+articleId.data.pc_article[i], {
        });
        this.article.push(article.data);
      }
    },
    async getArt(id) {
      const article = await this.$axios.get("article/"+id, {
      });
      this.item = article.data.body;
    },
    async getData_magazine() {
      const magazine = await this.$axios.get("magazine", {
      });
      this.magazine = magazine.data;
    },
    showModal(id) {
      this.visible = true;
      this.getArt(id)
      this.options.autoScrolling = false
    },
    closeModal(){
      this.options.autoScrolling = true
      this.visible = false;
      this.item = {}
    },
    onCancel() {
      this.options.autoScrolling = true
    },
  },
}
</script>
<style scoped>
.homeCon{
  width: 100%;
  height: fit-content;
  background-color: #000;
  transform: translate(0,0,0);
}
a {
    color: #fff;
    text-decoration: none;
}
.router-link-active {
    color: #fff;
    text-decoration: none;
}
.footer{
  height: 20px !important;
}
.mainPage,
.articlePage,
.magezinePage,
.activityPage {
  width: 100%;
  height: 100vh;
  background-color: #000;
}
hr {
  width: calc(100vw - 10px);
  border: none;
  height: 1px;
  background: #888;
  margin: 5px;
}
.mainPage img {
  width: 100%;
  height: inherit;
  object-fit: cover;
}
#particles-js {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: #000;
    background-image: url("https://www.steppyplus.com/static/img/steppy.b95bf59.png");
    background-repeat: no-repeat;
    background-size: 20%;
    background-position: 50% 50%;
}
.articlePage {
  color: #fff;
  padding-top: 8vh;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  position: relative;
}
.articlePage .box {
  border: #888 1px solid;
  border-bottom: none;
  border-left: none;
  cursor: pointer;
}
.articlePage .box4{
  border-right: none;
}
.articlePage .box .boxCon{
  height: calc(75vh - 2px);
  position: relative;
}
.articlePage .box .boxCon img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
}
.articlePage .box .boxCon .info{
  width: 100%;
  height: 30%;
  background-image: linear-gradient(to top,rgba(0,0,0,1) 50%,rgba(0,0,0,0));
  position: absolute;
  bottom: 0;
  z-index: 1;
  display: flex;
  padding-left: 5%;
  flex-direction: column;
  justify-content: flex-end;
}
.articlePage .box .boxCon .info .title {
  font-size: 1vw;
  line-height: 30px;
}
.articlePage .box .boxCon .info .author {
  font-size: 0.8vw;
  line-height: 25px;
}
.articlePage .listBox {
  width: 100%;
  height: 8vh;
  line-height: 8vh;
  text-align: right;
  font-size: 1.8vw;
  position: absolute;
  bottom: 0;
}
.articlePage .listBox .toArticle{
  width: 25%;
  padding: 0 10px;
  margin-left: 75%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.articlePage .listBox .toArticle .con{
  width: fit-content;
}
.articlePage .listBox .toArticle .icon{
  width: 1.8vw;
  height: 1.8vw;
  background: transparent url('../../assets/enterIcon.png') center no-repeat;
  background-size: 100%;
}
/* .articlePage .listBox .toArticle::after{
  content: url('../../assets/enterIcon.png');
  width: 1.8vw;
  height: 1.8vw;
} */
.boxCon1{
  margin-top: 9vh;
  border-top: #888 1px solid;
  border-bottom: #888 1px solid;
}
.boxCon2{
  margin-top: 0;
  border-bottom: #888 1px solid;
}
.boxCon3{
  margin-top: 17vh;
  border-top: #888 1px solid;
}
.boxCon4{
  margin-top: 9vh;
  border-top: #888 1px solid;
  border-bottom: #888 1px solid;
}
.modal /deep/ .ant-modal {
  height: 75vh;
  overflow: hidden;
  padding: 0;
  border-radius: 0;
}
.modal /deep/ .ant-modal-content {
  height: 100%;
  overflow: hidden;
  background-color: #000;
  border: #fff 1px solid;
  color: #fff;
}
.modal /deep/ .ant-modal-body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal /deep/ .ant-modal-body img,
.modal /deep/ .ant-modal-body svg{
  width: 100% !important;
  max-width: 100%;
  height: auto !important;
  object-fit: contain;
}
.modal /deep/ .ant-modal-body h1{
  color: #fff;
  font-size: 1.2vw;
}
.modal /deep/ .ant-modal-body p,
.modal /deep/ .ant-modal-body span,
.modal /deep/ .ant-modal-body strong,
.modal /deep/ .ant-modal-body section{
  font-size: 0.75vw !important;
  color: #fff !important;
  /* background-color: #000 !important; */
  background-image: none !important;
  margin: 0;
  filter: drop-shadow(0 0 0.4px #000);
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar {
  width: 1.5vh;
  background: #000;
  border: 1px solid #fff;
  display: block;
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar-thumb {
  background-color: #fff;
}
.modal .return {
  color: #fff;
  width: 5vh;
  height: 5vh;
  border-radius: 2.5vh;
  border: #fff 1px solid;
  position: fixed;
  z-index: 5;
  left: calc(50% - 2.5vh);
  bottom: 5%;
  background: transparent url("../../assets/return.png") center no-repeat;
  background-size: 60%;
}
.magezinePage {
  color: #fff;
  padding-top: 8vh;
  box-sizing: border-box;
  position: relative;
  background: #000 url('../../assets/m.png') center no-repeat;
  background-size: contain;
}
.magezinePage .listBox {
  width: 100%;
  height: fit-content;
  font-size: 1.8vw;
  position: absolute;
  bottom: 0;
}
.magezinePage .listBox .box{
  width: 100%;
}
.magezinePage .listBox .box .con{
  width: 25%;
  padding: 0 10px;
  margin-left: 75%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.magezinePage .listBox .box .con .icon{
  width: 1.8vw;
  height: 1.8vw;
  background: transparent url('../../assets/enterIcon.png') center no-repeat;
  background-size: 100%;
}
.activityPage {
  background: #000 url('../../assets/stepinto.png') center no-repeat;
  background-size: contain;
  color: #fff;
  padding-top: 8vh;
  box-sizing: border-box;
  position: relative;
}
.activityPage .listBox {
  width: 100%;
  height: fit-content;
  text-align: right;
  font-size: 1.8vw;
  position: absolute;
  bottom: 0;
}
.activityPage .listBox .toActivity{
  width: 25%;
  padding: 0 10px;
  margin-left: 75%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.activityPage .listBox .toActivity .con{
  width: fit-content;
}
.activityPage .listBox .toActivity .icon{
  width: 1.8vw;
  height: 1.8vw;
  background: transparent url('../../assets/enterIcon.png') center no-repeat;
  background-size: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/pc/Home.vue